import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';

import { PVI_NO_STYLES_CLASSNAME } from 'utils/helpers/inclusion';
import NextLink from '../NextLink';

import styles from './styles.module.scss';

const CustomLink = ({
	title,
	tooltip,
	href,
	icon,
	rel,
	className,
	iconClassName,
	iconWrapperClassName,
	theme,
	target,
	...props
}) => {
	const linkCx = cx(
		styles.link,
		styles[theme],
		className,
		PVI_NO_STYLES_CLASSNAME
	);

	const iconWrapperCx = cx(styles.iconWrapper, iconWrapperClassName);

	return (
		<NextLink
			href={href}
			className={linkCx}
			title={tooltip}
			rel={rel}
			target={target}
			{...props}
		>
			{title}
			{icon && (
				<span className={iconWrapperCx}>
					<Icon
						icon={icon}
						className={iconClassName}
						useClassName={PVI_NO_STYLES_CLASSNAME}
					/>
				</span>
			)}
		</NextLink>
	);
};

CustomLink.propTypes = {
	icon: PropTypes.string,
	title: PropTypes.string,
	tooltip: PropTypes.string,
	href: PropTypes.string.isRequired,
	theme: PropTypes.oneOf(['primaryButton']),
	className: PropTypes.string,
	iconClassName: PropTypes.string,
	iconWrapperClassName: PropTypes.string,
	rel: PropTypes.string,
	target: PropTypes.string
};

CustomLink.defaultProps = {
	target: '_self'
};

export default CustomLink;
